'use strict';

const $ = require('jquery');
const visibleClass = 'is-visible';

const addClass = (element, className) =>
	$(element).addClass(className);

const removeClass = (element, className) =>
	$(element).removeClass(className);

module.exports = function visibleIf({ form, elements, condition }) {

  if(!form) {
    return;
  }

  const onVisible = () => show(elements);
  const onNotVisible = () => hide(elements);
  const testCondition = () => condition(form);

  const test = () => testCondition() ?
    onVisible() :
    onNotVisible();

  form.addEventListener('change', test);
  test();

}

function show(elements) {
  [].forEach.call(elements, element =>
    addClass(element, visibleClass));
}

function hide(elements) {
  [].forEach.call(elements, element =>
    removeClass(element, visibleClass));
}